import { formatWholeNumber } from '@/utils/number';

const LABEL_CHAR_PX = 7.2;
const VALUE_CHAR_PX = 14;
const UNIT_CHAR_PX = 7;
const UNIT_GAP_PX = 4;
const REGULAR_CARD_PADDING_PX = 32;
const COMPACT_CARD_PADDING_PX = 24;
const PLACEHOLDER_VALUE_CHARS = 6;
const LABEL_WORD_SEPARATOR = ' ';

export interface StatCardText {
  label: string;
  value: number | string | undefined;
  unit?: string | undefined;
}

export interface StatCardWidths {
  regularPx: number;
  compactPx: number;
  compactMinPx: number;
}

export const getStatValueText = (value: StatCardText['value']): string =>
  typeof value === 'string' ? value : formatWholeNumber(value);

export function getStatCardWidths({ label, value, unit }: StatCardText): StatCardWidths {
  const labelPx = label.length * LABEL_CHAR_PX;
  const longestWordPx =
    Math.max(...label.split(LABEL_WORD_SEPARATOR).map((word) => word.length)) * LABEL_CHAR_PX;
  const valueChars = value === undefined ? PLACEHOLDER_VALUE_CHARS : getStatValueText(value).length;
  const unitPx = unit ? unit.length * UNIT_CHAR_PX + UNIT_GAP_PX : 0;
  const valuePx = valueChars * VALUE_CHAR_PX + unitPx;

  return {
    regularPx: Math.max(labelPx, valuePx) + REGULAR_CARD_PADDING_PX,
    compactPx: Math.max(labelPx, valuePx) + COMPACT_CARD_PADDING_PX,
    compactMinPx: Math.max(longestWordPx, valuePx) + COMPACT_CARD_PADDING_PX,
  };
}
